<script>
import { tableRelevant } from "@/pages/projectImpl/js/utils";

export default {
  name: "index",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  model: {
    prop: "visible",
    event: "change",
  },
  data() {
    return {
      tabKey: "1",
      columns: [
        {
          title: "关联对象",
          dataIndex: "name",
        },
        {
          title: "关联时间",
          dataIndex: "relevancyTime",
        },
      ],
      table: tableRelevant.call(this),
    };
  },
  watch: {
    visible(val) {
      val && this.tabChange(1);
    },
  },
  methods: {
    tabChange(index = 1) {
      let Http = null;
      switch (+index) {
        case 1:
          Http = this.$http.CourseResource.resourcePackageDetailsRelevancy;
          this.columns = [
            { title: "资源包名称", dataIndex: "resourcePackageName" },
            { title: "关联时间", dataIndex: "relevancyTime" },
          ];
          break;
        case 2:
          Http = this.$http.CourseResource.courseMaterialFile;
          this.columns = [
            { title: "课程名称", dataIndex: "courseName" },
            { title: "课时名称", dataIndex: "childCourseName" },
            { title: "关联时间", dataIndex: "relevancyTime" },
          ];
          break;
        case 3:
          Http = this.$http.Content.GetFileResourceIncidenceList;
          this.columns = [
            { title: "游戏名称", dataIndex: "relevancyName" },
            { title: "游戏类型", dataIndex: "contentTypeName" },
            { title: "关联时间", dataIndex: "relevancyTime" },
          ];
      }
      const Params = {
        fileResourceId: this.info.id,
      };
      this.table = tableRelevant.call(this);
      this.table.tableLoading = true;
      Http(Params).then((res) => {
        this.table.tableDataSource = res.data.map(m => {
          if (index == 3) {
            m.contentTypeName = this.$data._contentType[m.contentType];
          }
          return m;
        });
        this.table.tablePagination.total = res.data.length;
        this.table.tablePagination.current = 1;
      }).finally(() => {
        this.table.tableLoading = false;
      });
    },
    modalCancel() {
      this.tabKey = "1";
      this.$emit("change", false);
    },
  },
};
</script>

<template>
  <a-modal :title="info.name" :visible="visible" @cancel="modalCancel" width="900px" :footer="null"
           :bodyStyle="{paddingTop: '10px'}">
    <a-tabs v-model="tabKey" default-active-key="1" @change="tabChange">
      <a-tab-pane key="1" tab="关联课程资源" />
      <a-tab-pane key="2" tab="关联课时" force-render />
      <a-tab-pane key="3" tab="关联游戏" />
    </a-tabs>
    <a-table :columns="columns"
             :rowKey="text => text.resourcePackageId || text.childCourseId || text.contentId"
             :scroll="{y: 350}"
             :pagination="table.tablePagination"
             :loading="table.tableLoading"
             :dataSource="table.tableDataSource">
    </a-table>
  </a-modal>
</template>

<style scoped lang="less">

</style>
